module.exports = {'common.greeting':'Oh hello, my dear friend!'}